export const apiSettings = {
    uri: 'https://siicartago.confecamaras.co/librerias/wsRestSII/v1/',
    credentials: {
        "codigoempresa": 10, 
        "usuariows": "cccartago", 
        "clavews": "vn7uininga"
    }
};